import clsx from 'clsx';
import { ReactNode } from 'react';
import { useEscalateFills } from './fills';

export function buildDispatchPayload(
  updateType: 'dispatch' | 'arrival',
  alarmId: string,
  responder: string,
  notes: string,
  timestamp: number,
  dispatchStatus?: string,
  images?: File[]
) {
  if (images?.length) {
    const form = new FormData();
    form.append('update_type', updateType);
    if (dispatchStatus) form.append('dispatch_status', dispatchStatus);
    form.append('responder_type', responder);
    form.append('comment', notes.trim());
    form.append('timestamp', String(timestamp));
    form.append('alarm_id', alarmId);
    images.forEach((img) => form.append('snapshots', img));
    return form;
  }
  return JSON.stringify({
    update_type: updateType,
    dispatch_status: dispatchStatus,
    responder_type: responder,
    comment: notes.trim(),
    timestamp,
    alarm_id: alarmId,
  });
}

export function withSubSituation(text: string, subSituation?: string): string {
  return !subSituation || text.includes(subSituation)
    ? text
    : `${text.trimEnd()} - ${subSituation}`;
}

export const LABEL = 'font-medium dark:text-ondark-text-1 text-onlight-text-1';

export const INPUT_CLASS =
  'dark:text-ondark-text-1 text-onlight-text-1 w-full rounded border border-onlight-bg-3 px-2 py-1 text-sm dark:border-ondark-line-3 focus:outline-none focus:ring-1 focus:ring-primary-500';

export type Field = (step: number) => ReactNode;

export function badge(n: number, active: boolean) {
  return <StepBadge n={n} active={active} />;
}

function StepBadge({ n, active }: { n: number; active: boolean }) {
  const fills = useEscalateFills();

  return (
    <span
      className={clsx(
        'flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-xs font-semibold leading-none transition-colors',
        active
          ? 'bg-primary-800 text-white'
          : clsx(fills.badge, 'text-ondark-text-3 dark:text-onlight-line-3')
      )}
    >
      {n}
    </span>
  );
}

export function renderFields(fields: Field[], start = 2) {
  return fields.map((render, i) => (
    <div key={start + i} className="contents">
      {render(i + start)}
    </div>
  ));
}
